module.exports = __webpack_public_path__ + "assets/stimulus.7f9eeef2.svg";